import Cookies from "js-cookie";
import { API_BASE_URL } from "./api/apiServices";

// Generate Device ID
export const getDeviceId = () => {
    let id = Cookies.get("device_id");
    if (!id) {
        id = "dev-" + Math.random().toString(36).substring(2, 15);
        Cookies.set("device_id", id, { expires: 30 });
    }
    return id;
};

// Get IP
export const getIPAddress = async () => {
    try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip;
    } catch (e) {
        return "0.0.0.0";
    }
};




export const sendVisitLog = async (pageUrl: string) => {
    const country = localStorage.getItem("userCountry") || Cookies.get("userCountry") || "Unknown";
    const state = localStorage.getItem("userState") || Cookies.get("userState") || "Unknown";

    const payload = {
        deviceId: getDeviceId(),
        pageUrl,
        country,
        state,
        ipAddress: await getIPAddress(),
        consentStatus: Cookies.get("cookieConsent") === "true"
    };

    await fetch(`${API_BASE_URL}common/createUserVisitLog`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
};

